import React, { useMemo } from 'react';
import './MeterReadingPlausibilityIndicator.less';
import Icon from '@mdi/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { resolvePlausibilityIndicator } from '../../../helper/PlausibilityHelper';

interface IMeterReadingPlausibilityIndicatorProps {
    readingValue?: number;
    minimumValue?: number;
    maximumValue?: number;
    /** Spells the hint out ("Messwert höher als erwartet") instead of showing the arrow. */
    asText?: boolean;
    className?: string;
}

const MeterReadingPlausibilityIndicator = ({ readingValue, minimumValue, maximumValue, asText, className }: IMeterReadingPlausibilityIndicatorProps) => {
    const { t } = useTranslation();

    const indicator = useMemo(
        () => resolvePlausibilityIndicator(readingValue, minimumValue, maximumValue),
        [readingValue, maximumValue, minimumValue],
    );

    if (!indicator) return null;

    if (asText) {
        return <span className={classNames('meter-reading-plausibility-indicator text-amber-700', className)}>{t(indicator.textKey)}</span>;
    }

    return (
        <span className={classNames('meter-reading-plausibility-indicator', className)}>
            {/*FIXME: Tooltip needs functionality for positioning, otherwise there will be horizontal overflow on mobile screens.*/}
            {/*<Tooltip tooltipText={t(indicator.tooltipKey)} width={'w-40 md:w-64'}>*/}
            <span className={'sr-only'}>{t(indicator.tooltipKey)}</span>
            <Icon aria-hidden={true} path={indicator.path} size={1.1} color={'#D97706'} />
            {/*</Tooltip>*/}
        </span>
    );
};

export default MeterReadingPlausibilityIndicator;
